<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-toolbar>
          <v-toolbar-title>Quản lý hình ảnh</v-toolbar-title>
          <v-spacer/>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nhập từ khóa"
            single-line
            hide-details
            clearable
          />
          <v-spacer/>
          <v-btn
            color="primary"
            dark
            class="mb-2"
            v-on:click="showDialog()"
          >
            <v-icon>mdi-plus</v-icon>
            thêm mới
          </v-btn>
          <Form 
            :showDialog="dialog" 
            :item="item" 
            @confirmed="onConfirmed" 
            @cancelled="onCancelled"
          />
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row v-if="loading">
      <v-col cols="12">
        <div  class="text-center">
          <v-progress-circular
            indeterminate
            size="50"
            color="primary"
          />
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="(item, index) in items"
        :key="index"
        cols="2"
        md="1"
      >
        <v-hover v-slot="{ hover }">
          <v-card
            :elevation="hover ? 15 : 0"
            :class="{ 'on-hover': hover }"
          >
            <v-img
              :src="`${apiBaseUrl}/uploads/${item.path}`"
              lazy-src="@/assets/NoImage.jpg"
              aspect-ratio="1"
              class="grey lighten-2"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  />
                </v-row>
              </template>
            </v-img>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="text-center">
          <v-pagination
            v-model="currentPage"
            :length="totalPages"
            @input="handlePageChange"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
  import Form from '@/views/admin/images/Form';
  import { mapState } from 'vuex';
  export default {
    components: {
      Form
    },
    data: () => ({
      loading: false,
      dialog: false,
      dialogDelete: false,
      search: '',
      currentPage: 1,
      totalPages: 0,
      items: [],
      editedIndex: -1,
      item: {}
    }),
    computed: {
      ...mapState([
        'config'
      ]),
      formTitle () {
        return this.editedIndex === -1 ? 'thêm mới' : 'cập nhật';
      },
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    mounted() {
      this.initialize();
    },
    methods: {
      getRequestParams(page) {
        let params = {};

        if (page) {
          params["page"] = page;
        }

        if(this.search){}

        return params;
      },
      handlePageChange(value) {
        this.currentPage = value;
        this.initialize();
      },
      initialize () {
        const params = this.getRequestParams(
          this.currentPage,
        );
        this.loading = true;
        let request = {
          params: params
        };
        axios.get("api/v1/images", request)
          .then(response => {
            this.items = response.data.data;
            const caluTotalPage = response.data.total/response.data.per_page;
            this.totalPages = Math.ceil(caluTotalPage);
            this.loading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      showDialog(item=null){
        this.item = item||{};
        this.dialog = true;
      },

      onConfirmed(item) {
        this.dialog = false;
        this.initialize();
      },
      onCancelled () {
        this.dialog = false;
      },
      close () {
        this.dialog = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      }
    }
  }
</script>